// extracted by mini-css-extract-plugin
export default {"MainModal":"MainModal_MainModal__obZwa"};